import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Dialog from '../../atoms/feedback/Dialog'
import FormItem from '../../molecules/inputs/FormItem'
import { AttachmentIcon } from '../../atoms/display/Icons'
import Label from '../../atoms/display/Label'
import Button from '../../atoms/inputs/Button'
import { CompanySelectors } from '../../../store/company/selectors'
import SelectString from '../../atoms/inputs/SelectString'
import { AgreementActions } from '../../../store/agreement'
import FileSelectButton from '../../atoms/inputs/FileSelectButton'
import { AgreementSelectors } from '../../../store/agreement/selectors'
import ComboboxString from '../../atoms/inputs/ComboboxString'

type Props = {
  open: boolean
  onClose: () => void
}

export default function AgreementCreateDialog({ open, onClose }: Props) {
  const clients = useSelector(CompanySelectors.clients)
  const [name, setName] = useState<string | undefined>()
  const [clientId, setClientId] = useState<string | undefined>()
  const [file, setFile] = useState<File | undefined>()
  const dispatch = useDispatch()
  const selectableClients = clients.filter((client) => client.representative?.acceptedAt != null)
  const agreements = useSelector(AgreementSelectors.agreements)
  const names = Array.from(new Set(agreements.map((agreement) => agreement.name)))

  const handleSelect = useCallback((files: File[]) => {
    setFile(files[0])
  }, [])

  const handleCreate = useCallback(() => {
    if (name === undefined || clientId === undefined || file === undefined) {
      return
    }
    dispatch(AgreementActions.createAgreement({ name, clientId, file }))
    onClose()
  }, [clientId, dispatch, file, name, onClose])

  const handleClose = useCallback(() => {
    setName(undefined)
    setClientId(undefined)
    setFile(undefined)
    onClose()
  }, [onClose])

  return (
    <Dialog
      open={open}
      title="新規契約の作成"
      onClose={handleClose}
      actions={
        <FlexRow>
          <Button disabled={name == null || clientId == null || file == null} onClick={handleCreate}>
            契約書作成
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <FormItem label="契約書名">
          <ComboboxString
            value={name}
            options={names}
            onChange={(newValue) => setName(newValue ?? undefined)}
            freeSolo
          />
        </FormItem>
        <FormItem label="取引先">
          <SelectString
            value={clientId}
            items={selectableClients.map((client) => ({
              value: client.id,
              label: client.name,
            }))}
            onChange={setClientId}
          />
        </FormItem>
        <FlexRow align="center">
          <FileSelectButton accepts={['application/pdf']} onSelect={handleSelect}>
            契約書ファイルの選択
          </FileSelectButton>
          {file ? (
            <FlexRow align="center">
              <AttachmentIcon />
              <Label text={file.name} />
            </FlexRow>
          ) : (
            <Label text="契約書のPDFファイルを選択してください" />
          )}
        </FlexRow>
      </FlexColumn>
    </Dialog>
  )
}
